import { deburr } from 'lodash-es';

export const API_NAME_REGEX = /^[A-Z]\w*$/i;

/**
 * `true` when `name` is a valid apiName: a non-empty ASCII identifier that
 * starts with a letter and otherwise contains only letters, digits, or `_`.
 * This is the rule REST routes and GraphQL type names rely on.
 */
export function isValidApiName(name: string): boolean {
	return API_NAME_REGEX.test(name);
}

/**
 * Coerces a raw name into a valid apiName: transliterate Latin characters to
 * ASCII, treat characters invalid in an apiName as word separators, apply the
 * casing convention, then prefix the letter `n` when the result would start
 * with a digit. Returns `null` when nothing valid remains (e.g. a name made
 * only of symbols).
 *
 * Mirror of the engine's `to_valid_api_name` (`crates/monospace/src/naming.rs`);
 * keep the two in sync via the shared test corpus.
 */
export function toValidApiName(name: string, applyCase: (name: string) => string): string | null {
	const ascii = deburr(name);
	const cased = applyCase(ascii.replaceAll(/\W+/g, ' ').trim());
	const candidate = /^\d/.test(cased) ? `n${cased}` : cased;

	return isValidApiName(candidate) ? candidate : null;
}
